const moobileContact = {
  ticketList: '/api/v1/admin/ticket-list',
  closeTicket: '/api/v1/admin/close-ticket',
}

export const mobileContactApiRoutes = {
  ...moobileContact,
}
